import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom';
import { NotificationContainer } from "react-notifications";

import MiddlewareLMap from '../components/floorPlan/MiddlewareLMap';
import Directory from '../components/directory';

const urlid = window.location.href.split('/')[5];

const register = () => {
   return(<h2>register</h2>)
}

const conference = () => {
   return(<h2>conference</h2>)
}
const FallBackUI = () => {
   return (<div className='gx-text-center'>
      <h1>404</h1>
      <h1 className='error-line'>Sorry, the page you visited does not exist.</h1>
   </div>
   )
}
const AppRoutes = (props) => {
   const basepath = `/${urlid}/`;
   return (
      <>
         <Switch>
            <Route
               exact
               path="/"
               render={() => {
                  return (<>
                     <Redirect to={basepath + 'floorplan'} />
                     {!!basepath && <FallBackUI />}
                  </>
                  )
               }}
            />
            <Route exact path={basepath + 'floorplan'} component={MiddlewareLMap} />
            <Route path={basepath + 'register'} component={register} />
            <Route path={basepath + 'conference'} component={conference} />
            <Route exact path={basepath + 'directory'} component={Directory} />
            <Route render={() => <FallBackUI />} />
         </Switch>
         <NotificationContainer />
      </>
   )
}

export default AppRoutes;
